<cap-content-header>
  <cap-title>
    {{ "grundbuchmeldung.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<form (ngSubmit)="onSubmit()" [meta]="grundbuchmeldung" #form="ngForm">
  <div class="row mb-0">
    <cap-tagebuch-nummer
      (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.tagebuchnummer = $event)"
      [hasfocus]="true"
      [ngModel]="grundbuchmeldung && grundbuchmeldung.tagebuchnummer"
      [searchMode]="gbGemeindeSearchMode"
      class="col-md-12 pt-2"
      heading="Grundbuchgeschäft"
      id="grundbuchamtId"
      name="grundbuchamtId"></cap-tagebuch-nummer>
  </div>
  @if (grundbuchmeldung && grundbuchmeldung.mGeschaeftsstatus?.access !== "NONE") {
    <cap-form-row class="mb-md-2">
      <cap-form-control column-classes="col-md-2,col-md-3" labelKey="suche.status">
        <select
          (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.geschaeftsstatus = $event)"
          [ngModel]="grundbuchmeldung && grundbuchmeldung.geschaeftsstatus"
          name="geschaeftsstatus">
          <option [ngValue]=""></option>
          @for (status of grundbuchmeldung.geschaeftsstatusList; track status) {
            <option [ngValue]="status">{{ status | translate }}</option>
          }
        </select>
      </cap-form-control>
      @if (grundbuchmeldung && grundbuchmeldung.mRegistraturText?.access !== "NONE") {
        <cap-form-control column-classes="col-md-2,col-md-2" labelKey="RegistraturText">
          <input
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.registraturText = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.registraturText"
            name="grundbuchmeldung.registraturText"
            type="text" />
        </cap-form-control>
      }
    </cap-form-row>
  }
  <div class="row mt-md-2">
    <cap-grundstueck-nummer
      (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.grundstueckNummer = $event)"
      [mitRegion]="true"
      [ngModel]="grundbuchmeldung && grundbuchmeldung.grundstueckNummer"
      [searchMode]="gbGemeindeSearchMode"
      class="col-md-12"
      heading="BeteiligteGrundstuecke"
      name="grundstueckNummer"></cap-grundstueck-nummer>
    <cap-form-row class="col-md-12">
      <cap-form-control column-classes="col-md-2,col-md-2" invalidKey="EingabeMussValideEgridSein" labelKey="EGRID">
        <input
          (ngModelChange)="grundbuchmeldung && grundbuchmeldung.egrid && (grundbuchmeldung.egrid.value = $event)"
          [ngModel]="grundbuchmeldung && grundbuchmeldung.egrid && grundbuchmeldung.egrid.value"
          name="egrid.value"
          type="text" />
      </cap-form-control>
    </cap-form-row>
  </div>

  <cap-form-row class="mt-5">
    <div class="col-md-6">
      <h3 class="title-divider-suche">{{ "meldungEingangsdatumHeading" | translate }}</h3>
      <cap-form-row column-classes="col-md-1,col-md-1">
        <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="DatumVon">
          <cap-datepicker
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.eingangsDatumVon = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.eingangsDatumVon"
            name="eingangsDatumVon"></cap-datepicker>
        </cap-form-control>
        <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="DatumBis">
          <cap-datepicker
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.eingangsDatumBis = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.eingangsDatumBis"
            name="eingangsDatumBis"></cap-datepicker>
        </cap-form-control>
      </cap-form-row>
    </div>

    <div class="col-md-6">
      <h3 class="title-divider-suche">{{ "meldungAbschlussdatumHeading" | translate }}</h3>
      <cap-form-row column-classes="col-md-1,col-md-1">
        <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="DatumVon">
          <cap-datepicker
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.abschlussDatumVon = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.abschlussDatumVon"
            name="abschlussDatumVon"></cap-datepicker>
        </cap-form-control>
        <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="DatumBis">
          <cap-datepicker
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.abschlussDatumBis = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.abschlussDatumBis"
            name="abschlussDatumBis"></cap-datepicker>
        </cap-form-control>
      </cap-form-row>
    </div>
  </cap-form-row>

  <cap-form-row class="mt-2">
    <div class="col-md-6">
      <h3 class="title-divider-suche">{{ "meldungErwerberVeraeussererHeading" | translate }}</h3>
      <cap-form-row column-classes="col-md-4,col-md-8">
        <cap-form-control labelKey="NameOderFirma">
          <input
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.name = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.name"
            name="grundbuchmeldung.name"
            type="text" />
        </cap-form-control>
      </cap-form-row>
      <cap-form-row column-classes="col-md-4,col-md-8">
        <cap-form-control labelKey="Vorname">
          <input
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.vorname = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.vorname"
            name="grundbuchmeldung.vorname"
            type="text" />
        </cap-form-control>
      </cap-form-row>
    </div>

    <div class="col-md-6">
      <h3 class="title-divider-suche">{{ "meldungGebaeudeHeading" | translate }}</h3>
      <cap-form-row column-classes="col-md-4,col-md-8">
        <cap-form-control labelKey="GebäudeVersicherungsNummer">
          <input
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.gebaeudeversicherungsNr = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.gebaeudeversicherungsNr"
            name="grundbuchmeldung.gebaeudeversicherungsNr"
            type="text" />
        </cap-form-control>
      </cap-form-row>
      <cap-form-row column-classes="col-md-4,col-md-8">
        <cap-form-control invalidKey="EingabeMussValideNummerSein-EGID" labelKey="EGID">
          <input
            (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.gwrEgid = $event)"
            [ngModel]="grundbuchmeldung && grundbuchmeldung.gwrEgid"
            name="grundbuchmeldung.gwrEgid"
            type="text" />
        </cap-form-control>
      </cap-form-row>
    </div>
  </cap-form-row>

  @if (grundbuchmeldung) {
    <div class="row mt-2">
      <cap-bearbeitungsstatus-selection
        (ngModelChange)="grundbuchmeldung && (grundbuchmeldung.bearbeitungsstatus = $event)"
        [disabled]="grundbuchmeldung?.mBearbeitungsstatus?.access === 'NONE'"
        [ngModel]="grundbuchmeldung && grundbuchmeldung.bearbeitungsstatus"
        class="col-md-3"
        name="bearbeitetstatusSelection"></cap-bearbeitungsstatus-selection>
    </div>
  }
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
